var _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 39,
    height: 39,
    viewBox: "0 0 39 39",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.5 10.2818C19.5 6.03928 22.9393 2.59998 27.1818 2.59998H36.4V11.8182C36.4 16.0607 32.9607 19.5 28.7182 19.5H19.5V10.2818Z",
    fill: "#D9C300"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.59961 27.1818C2.59961 22.9393 6.03891 19.5 10.2814 19.5H19.4996V28.7182C19.4996 32.9607 16.0603 36.4 11.8178 36.4H2.59961V27.1818Z",
    fill: "#D9C300"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M36.4 27.1818C36.4 22.9393 32.9607 19.5 28.7182 19.5H19.5V28.7182C19.5 32.9607 22.9393 36.4 27.1818 36.4H36.4V27.1818Z",
    fill: "#D9C300"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M19.4996 10.2818C19.4996 6.03928 16.0603 2.59998 11.8178 2.59998H2.59961V11.8182C2.59961 16.0607 6.03891 19.5 10.2814 19.5H19.4996V10.2818Z",
    fill: "#D9C300"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.85e4f59da406287a06b18e953001aa6c.svg";
export { ForwardRef as ReactComponent };